export default "__VITE_ASSET__Cufy2Toc__"